// @ts-nocheck

import PropTypes from "prop-types";
import filterStyle from "./dbOperationSearchForm.module.scss";
import React from "react";

export const DbOperationSearchSelect = ({ selections, removeTerm, addTerm, terms, submit }) => {
  return (
    <ul className={`${filterStyle.dbOperationSelectList}`}>
      {selections.map((term, i) => (
        <li
          onClick={() => {
            addTerm(term);
          }}
          key={`filterSelection-${i}`}
        >
          <span
            style={{
              borderRadius: "7px",
              padding: "6px 11px",
              fontWeight: "bold",
            }}
          >
            {term.name}
          </span>
        </li>
      ))}
    </ul>
  );
};

DbOperationSearchSelect.propTypes = {
  selections: PropTypes.array,
  addTerm: PropTypes.func,
  removeTerm: PropTypes.func,
  terms: PropTypes.array,
  submit: PropTypes.func,
};
